jQuery( document ).ready( function( $ ) {

    $( '.news__search' ).keyup( function() {
        let s = $( this ).val();
        $('.article').hide();
        $('.article__description:contains(' + s + ')').parents('.article').show();
    });

});